import { Http } from '@/lib/http';
export class AppModulesService extends Http {
  constructor() {
    super();
    this.endpoint = 'modules/';
  }

  getAppModules() {
    return this.httpClient().get(`client-information`);
  }
  getModuleByName(name) {
    return this.httpClient().get(`${this.endpoint}${name}`);
  }
  getModuleWithProcesses() {
    return this.httpClient().get(`${this.endpoint}processes`);
  }
  getModuleNamesOnly() {
    return this.httpClient().get(`${this.endpoint}get-module/names`);
  }
}
